(() => {
  const pending = new Map();
  const loadScript = (template) => {
    const url = template.getAttribute('src');
    if (!url) return Promise.resolve();
    if (pending.has(url)) return pending.get(url);
    const existing = Array.from(document.scripts).find(script => script.getAttribute('src') === url);
    if (existing) return Promise.resolve();
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => { pending.delete(url); reject(new Error('Section resource unavailable')); };
      document.head.appendChild(script);
    });
    pending.set(url, promise);
    return promise;
  };
  const initialize = (section) => {
    if (section.dataset.zuqoResourcesLoading) return;
    section.dataset.zuqoResourcesLoading = 'true';
    const templates = Array.from(section.querySelectorAll('template[data-zuqo-script]'));
    templates.reduce((ready, template) => ready.then(() => loadScript(template)), Promise.resolve())
      .catch(() => { delete section.dataset.zuqoResourcesLoading; });
  };
  const observe = (root = document) => {
    const sections = new Set(Array.from(root.querySelectorAll('template[data-zuqo-script]')).map(template => template.closest('.shopify-section')).filter(Boolean));
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        initialize(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: window.matchMedia('(max-width: 749px)').matches ? '150px 0px' : '500px 0px' }) : null;
    sections.forEach(section => {
      if (observer) observer.observe(section);
      else initialize(section);
      ['pointerover', 'focusin', 'pointerdown'].forEach(event => section.addEventListener(event, () => initialize(section), { once: true, passive: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe(), {once:true});
  else observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
